import { render } from "./NewProjects.vue?vue&type=template&id=73c34af0"
import script from "./NewProjects.vue?vue&type=script&lang=js"
export * from "./NewProjects.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__